export const addExpenseHref = '/faturamento-tiss/despesas/novo';
